<app-state-section [state]="sectionState">
  <mat-card>
    <mat-card-header>
      <div class="w-100">
        <app-row gutter="x-sm" align="center">
          <app-col>
            <h6 class="my-0">{{'Shipments.GateTiming' | translate}}</h6>
          </app-col>
          <app-col cols="12" sm="auto">
            <div class="small text-400">{{'Shipments.TotalTime' | translate}} : {{'Shipments.Duration' | translate: etaTime}}</div>
          </app-col>
          <app-col cols="12" sm="auto">
            <app-icon class="d-inline-block align-middle text-primary mb-1" size="xs" name="link-icon"></app-icon>
            <a href="{{shipmentLogsUrl}}" target="_blank" style="text-decoration: none">{{'sharedFeatures.GateToGate.ShipmentLogs' | translate}}</a>
          </app-col>
        </app-row>
      </div>
    </mat-card-header>
    <mat-card-content>
      <mat-divider></mat-divider>
      <section>
        <ul class="timeline timeline--lg-bullet">
          <li class="d-none d-inline-sm">
            <app-row justify="flex-end">
              <app-col></app-col>
              <app-col cols="3">
                <p class="mt-0 mb-2 text-500 weight-semibod ml-4">{{"sharedFeatures.GateDefinition.DeviceDistance" | translate}}</p>
              </app-col>
              <app-col cols="3">
                <p class="mt-0 mb-2 text-500 weight-semibod ml-3">{{"Shipments.Time" | translate}}</p>
              </app-col>
              <app-col cols="2" *grantAccess="RolesConstants.EDIT_GATE_TO_GATE">
                <p class="mt-0 mb-2 text-500 weight-semibod text-center ml-5">{{"Shipments.Action" | translate}}</p>
              </app-col>
            </app-row>
          </li>

          <li class="timeline__item" *ngFor="let item of formatedShipment; let i = index; last as isLast">
            <div class="timeline__bullet">
              <span class="timeline__bullet-shape"></span>
            </div>
            <app-row [align]="i === 0 ? 'flex-start' : 'center'">
              <app-col>
                <div class="timeline__item-title">
                  <p class="weight-medium" *ngIf="item.action == ShipmentAction.AssignDriver">
                    {{ "Enum.ShipmentStatus." + item.action | translate}} {{item.createdBy?.userType === UserType.DRIVER && (item.createdBy?.firstName
                    && item.createdBy?.lastName) ? "(" + ("Shipments.DriverAccepted" | translate) + ")" : "(" + item.createdBy?.firstName + " " +
                    item.createdBy?.lastName + ")"}}
                    <ng-container *ngIf="enabledEmailFields.get('isShipmentAssignedEmailEnabled')">
                      <p class="small text-success weight-normal">
                        <app-icon name="right-tick-circle" class="mr-1 text-success" size="xs"></app-icon>
                        <span class="mr-1 small">{{"sharedFeatures.GateToGate.SentEmail" | translate}}</span>
                        <ng-container
                          *ngIf="attachmentEmailFields.get('IsShipmentAssignedDriverLicenseAttachmentEmailEnabled') || 
                        attachmentEmailFields.get('IsShipmentAssignedDriverIqamaAttachmentEmailEnabled') || 
                        attachmentEmailFields.get('IsShipmentAssignedTruckLicenseAttachmentEmailEnabled')"
                        >
                          <span class="small">{{"sharedFeatures.GateToGate.WithAttachment" | translate}}</span>
                        </ng-container>
                      </p>
                    </ng-container>
                    <ng-container class="p-2 my-1" *ngIf="item.isAutomatedDaleel">
                      <div class="flex align-center">
                        <span>
                          <app-icon
                            [name]="(item.headedStatus === ShipmentHeadedStatus.RightHeaded ? 'right-tick-circle' : 'warning-accent')"
                            class="mr-1 text-success"
                            size="xs"
                          ></app-icon>
                        </span>
                        <span
                          class="small weight-normal"
                          [ngClass]="{
                          'text-success': item.headedStatus === ShipmentHeadedStatus.RightHeaded,
                          'text-warn-dark': item.headedStatus === ShipmentHeadedStatus.WrongHeaded}"
                        >
                          {{'sharedFeatures.Enum.ShipmentHeadedStatus.' + item.headedStatus |translate}}
                        </span>
                      </div>
                    </ng-container>
                  </p>

                  <p class="weight-medium" *ngIf="item.order != null">{{ item?.order?.dropOffCustomerTitle}}</p>

                  <p class="weight-medium" *ngIf="item.action != ShipmentAction.AssignDriver && item.order == null">
                    {{ "Enum.ShipmentStatus." + item.action | translate}}
                    <ng-container
                      class="weight-medium"
                      *ngIf="(item.action == ShipmentAction.ArrivePickupLocation || item.action == ShipmentAction.ArriveDropOffLocation)  && item.isAutomatedMobile == true"
                    >
                      ({{ "Enum.ShipmentStatus.AutomatedMobile" | translate}})
                    </ng-container>
                    <ng-container class="weight-medium" *ngIf="item.isAutomatedAVL == true">
                      ({{ "Enum.ShipmentStatus.Automated_AVL" | translate}})
                    </ng-container>
                    <ng-container *ngIf="item.isEmailSent" class="my-1">
                      <p class="small text-success weight-normal">
                        <app-icon name="right-tick-circle" class="mr-1 text-success" size="xs"></app-icon>
                        <span class="mr-1 small">{{"sharedFeatures.GateToGate.SentEmail" | translate}}</span>
                        <ng-container *ngIf="item.isAttachmentSent">
                          <span class="small">{{"sharedFeatures.GateToGate.WithAttachment" | translate}}</span>
                        </ng-container>
                      </p>
                    </ng-container>
                    <ng-container class="p-2 my-1" *ngIf="item?.headedStatus">
                      <div class="flex align-center">
                        <span>
                          <app-icon
                            [name]="(item.headedStatus === ShipmentHeadedStatus.RightHeaded ? 'right-tick-circle' : 'warning-accent')"
                            class="mr-1 text-success"
                            size="xs"
                          ></app-icon>
                        </span>
                        <span
                          class="small weight-normal"
                          [ngClass]="{
                          'text-success': item.headedStatus === ShipmentHeadedStatus.RightHeaded,
                          'text-warn-dark': item.headedStatus === ShipmentHeadedStatus.WrongHeaded}"
                        >
                          {{'sharedFeatures.Enum.ShipmentHeadedStatus.' + item.headedStatus |translate}}
                        </span>
                      </div>
                    </ng-container>
                  </p>
                </div>
              </app-col>

              <app-col sm="3">
                <p
                  *ngIf="item?.avlDistance &&
            item.action == ShipmentAction.AssignDriver ||
            item.action == ShipmentAction.AcceptDriver ||
            item.action == ShipmentAction.Start ||
            item.action == ShipmentAction.ArrivePickupLocation ||
            item.action == ShipmentAction.GoodsLoaded ||
            item.action == ShipmentAction.ArriveDropOffLocation ||
            item.action == ShipmentAction.GoodsDelivered"
                >
                  <span class="timeline__item-content">{{(+item?.avlDistance)?.toFixed(2)}} {{"Shipments.km" | translate}}</span>
                </p>
              </app-col>

              <app-col cols="6" sm="3" class="">
                <div class="timeline__item__content text-nowrap">
                  <span class="h6 text-500 text-center d-inline-block mb-0">{{item?.createdAt | date : 'dd-MM-yyyy hh:mm aa'}}</span>
                  <small
                    class="small bg-400 text-white px-1 mx-1 radius-1 rect"
                    *ngIf="!itemsHistoryTextMap[item.id] && itemsHistoryCountMap[item.id]"
                    (mouseenter)="sectionState === SectionStateStatus.Ready && getItemUpdateHistory(item.id)"
                  >
                    {{itemsHistoryCountMap[item.id]}}
                  </small>

                  <small
                    class="small bg-400 text-white px-1 mx-1 radius-1 rect"
                    *ngIf="itemsHistoryTextMap[item.id]"
                    [matTooltip]="itemsHistoryTextMap[item.id]"
                    matTooltipPosition="above"
                  >
                    {{itemsHistoryCountMap[item.id]}}
                  </small>
                </div>
              </app-col>
              <app-col cols="6" sm="2" *grantAccess="RolesConstants.EDIT_GATE_TO_GATE">
                <div
                  class="text-right text-center-sm"
                  style="margin-top: -0.5rem; margin-bottom: -0.5rem"
                  *ngIf="item.action !== ShipmentAction.Create"
                >
                  <button
                    mat-icon-button
                    class="btn--small btn--square btn--icon brd-primary-lighter brd brd-1 bg-primary-lighter text-primary"
                    (click)="openEditTimeDialog(item.id, item.createdAt)"
                  >
                    <app-icon name="bold-edit" size="xs"></app-icon>
                  </button>
                </div>
              </app-col>
              <p *ngIf="shipment?.loadingOffTime && item.action == ShipmentAction.ArrivePickupLocation">
                {{"Shipments.WaitingTime" | translate}}:
                <span class="timeline__item-content text-warn">{{loadingOffTime}}</span>
              </p>

              <p
                *ngIf="shipment?.droppingOffTime &&
        item.action == ShipmentAction.ArriveDropOffLocation"
              >
                {{"Shipments.WaitingTime" | translate}}:
                <span class="timeline__item-content text-warn">{{droppingOffTime}}</span>
              </p>
              <div *ngIf="item.order != null">
                <ng-container>
                  <app-gate-to-gate-timeline *ngIf="shipment" [history]="item?.history" [isLast]="isLast"></app-gate-to-gate-timeline>
                </ng-container>
              </div>
            </app-row>
            <div class="timeline__item-separator" *ngIf="!isLast"></div>
          </li>
        </ul>
      </section>
    </mat-card-content>
  </mat-card>
</app-state-section>
